import React from 'react'
import Hero from '../hero'
import BackgroundCanvas from '../background-canvas'
import CaseStudiesContainer from '../case-studies-container'

const Home = ({ setElementScroll, pageName, match, st, vh, colours }) => {
  const active = (match && match.isExact) 
  return (
    <div className="home">
      <BackgroundCanvas active={active} colours={colours} />
      <Hero st={st} primary={true} active={ active && (st < vh ) } />
      <CaseStudiesContainer st={st} setElementScroll={setElementScroll} pageName={pageName} match={match} active={active} />
    </div>
  )
}

export default Home



// WEBPACK FOOTER //
// ./src/components/home-page/home.js